/**
 * validator
 * validtor check mixins
 *
 * @since 2018-08-15
 * @author kdydesign.kim
 */

export default {
  methods: {
    /*
      이름: validatorClear
      설명: 대상 컴포넌트의 Vee-validate ErrorBag 및 상태값을 초기화한다.
    */
    async validatorClear () {
      // 컴포넌트 에러백 초기화
      await this.errors.clear()

      // 컴포넌트 내부에 Vee-validate 대상 필드상태 초기화
      await this.$validator.reset()
    },
    /*
      이름: validateMixins
      설명: 모든 컴포넌트에 Vee-validate 인스턴스로 유효성 검사를 수행한다.
    */
    async validateMixins (scope = void 0, autoPopup = true, globalScope = false) {
      if (globalScope) {
        // TAMS, Global scope validate 방식 (Global Scope, 현재 화면 내 마운트된 모든 필드의 scope 내 validate 검사 수행 (상위, 하위 포함))
        await this.validatorClear()
        const descriptor = typeof scope !== 'undefined' ? `${scope}.*` : `*`
        const validate = await this.$validator.validate(descriptor)
        if (validate) {
          return true
        }

        // 유효성 검사 실패 시 Return False / ValidatePopup 출력
        if (autoPopup) {
          if (typeof scope !== 'undefined') {
            this.$validatePopUp.show(_.filter(this.$validator.errors.items, ['scope', scope]))
          } else {
            this.$validatePopUp.show(this.$validator.errors.items)
          }
        }
      } else {
        // 유효성 검사 수행
        const resValidate = await this.$validator.validateAll(scope)
        // 유효성 검사 성공 시 Return True
        if (resValidate) {
          return true
        }

        // 유효성 검사 실패 시 Return False / ValidatePopup 출력
        if (autoPopup) {
          this.$validatePopUp.show(this.errors)
        }
        // this.$validator.errors.items 의 field 값을 참조하여, 해당 에러가 어떤 인풋 필드의 에러인지 명시적으로 나타낼 것!
      }

      return false
    }
  }
}
